import React from 'react';
import { ShoppingCart, Mail } from 'lucide-react';

interface StockWarningProps {
  sku: string;
  qtyRequested: number;
  stockAvailable: number;
  onOrderAvailable: () => void;
  /** Aggiunge solo la quantità disponibile al carrello, senza creare un avviso di disponibilità. */
  onAddAvailableOnly?: () => void;
  variant?: 'popover' | 'inline';
}

export function StockWarning({ sku, qtyRequested, stockAvailable, onOrderAvailable, onAddAvailableOnly, variant = 'popover' }: StockWarningProps) {
  const missing = qtyRequested - stockAvailable;

  const inner = (
    <div className="space-y-2.5">
      <div className="flex items-start gap-2">
        <Mail className="w-4 h-4 text-amber-700 flex-shrink-0 mt-0.5" />
        <div>
          <div className="text-sm font-bold text-amber-900 leading-tight">
            Solo {stockAvailable} pz disponibili
          </div>
          <div className="text-xs text-amber-700 mt-0.5">
            Hai richiesto {qtyRequested} pz — {missing} pz non disponibili.
          </div>
        </div>
      </div>
      <button
        onClick={onOrderAvailable}
        className="w-full h-9 px-3 rounded-lg bg-[hsl(214,58%,41%)] text-white text-xs font-semibold flex items-center justify-center gap-2 hover:bg-[hsl(214,58%,46%)] transition-colors"
        data-testid={`stock-warning-order-btn-${sku}`}
      >
        <ShoppingCart className="w-3.5 h-3.5 flex-shrink-0" />
        Ordina {stockAvailable} + avvisami per {missing}
      </button>
      {onAddAvailableOnly && (
        <button
          onClick={onAddAvailableOnly}
          className="w-full h-8 px-3 rounded-lg border border-amber-300 bg-white text-amber-800 text-[11px] font-semibold flex items-center justify-center gap-2 hover:bg-amber-100 transition-colors"
          data-testid={`stock-warning-available-only-btn-${sku}`}
        >
          Aggiungi solo i {stockAvailable} disponibili (senza avviso)
        </button>
      )}
    </div>
  );

  if (variant === 'inline') {
    return (
      <div className="rounded-xl border-2 border-amber-300 bg-amber-50 p-3" data-testid={`stock-warning-${sku}`}>
        {inner}
      </div>
    );
  }

  return (
    <div
      className="absolute right-0 top-full mt-1.5 z-50 w-72 rounded-xl border-2 border-amber-300 bg-amber-50 shadow-xl p-3.5 text-left"
      data-testid={`stock-warning-${sku}`}
    >
      {inner}
    </div>
  );
}
